import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import colors from 'modules/common/components/ui/colors'
import { media, sizes } from 'modules/common/components/ui/utils'

export const P = styled.p`
  ${props => props.textDark &&
    `
      color: ${colors.GRAY_DARK};
    `
  }
  ${props => props.halfMargin &&
    ` 
      margin-top: calc(8rem / 16);
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginTop &&
    ` 
      margin-top: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginBottom &&
    ` 
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.doubleMarginBottom &&
    ` 
      margin-bottom: calc(32rem / 16);
    `
  }
  ${props => props.noMargin &&
    ` 
      margin: 0;
    `
  }
  ${props => props.noTopMargin &&
    ` 
      margin-top: 0;
    `
  }
  ${props => props.noBottomMargin &&
    ` 
      margin-bottom: 0;
    `
  }
  ${({white}) => white && 'color: white;'}
`

export const UL = styled.ul`
  margin: 1rem 0;
  padding: 0;
  ${props => props.plain &&
    `
      list-style: none;
    `
  }
  ${props => props.textDark &&
    `
      color: ${colors.GRAY_DARK};
    `
  }
  ${props => props.halfMargin &&
    ` 
      margin-top: calc(8rem / 16);
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginTop &&
    ` 
      margin-top: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginBottom &&
    ` 
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.noMargin &&
    ` 
      margin: 0;
    `
  }
  ${props => props.noBottomMargin &&
    ` 
      margin-bottom: 0;
    `
  }
  ${props => props.noTopMargin &&
    ` 
      margin-top: 0;
    `
  }
  .item__margin-bottom{
    margin-bottom: 1rem;
  }
`
export const H1 = styled.h1`
  font-size: calc(24rem / 16);
  line-height: 1.25;
  font-family: 'Open sans', Helvetica, Arial, sans-serif;
  font-weight: 300;
  color: ${colors.GRAY_DARK};
  margin-top: 1rem;
  margin-bottom: 1rem;
  &.title--main{
    font-weight: 500;
  }
  ${({bigger}) => bigger && 'font-size: calc(30rem / 16);'}
  ${({regular}) => regular && 'font-weight: 400 !important;'}
  ${({medium}) => medium && 'font-weight: 500 !important;'}
  ${({white}) => white && 'color: white;'}
  ${({textCenter}) => textCenter && 'text-align: center;'}
  ${props => props.halfMargin &&
    ` 
      margin-top: calc(8rem / 16);
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginTop &&
    ` 
      margin-top: calc(8rem / 16);
    `
  }
  ${props => props.halfMarginBottom &&
    ` 
      margin-bottom: calc(8rem / 16);
    `
  }
  ${props => props.doubleBottomMargin &&
    ` 
      margin-bottom: 2rem;
    `
  }
  ${props => props.doubleTopMargin &&
    ` 
      margin-top: 2rem;
    `
  }
  ${props => props.tripleBottomMargin &&
    ` 
      margin-bottom: 3rem;
    `
  }
  ${props => props.tripleTopMargin &&
    ` 
      margin-top: 3rem;
    `
  }
  ${props => props.noMargin &&
    ` 
      margin: 0;
    `
  }
  ${props => props.noBottomMargin &&
    ` 
      margin-bottom: 0;
    `
  }
  ${props => props.noTopMargin &&
    ` 
      margin-top: 0;
    `
  }
`

export const H2 = styled(H1.withComponent('h2'))`
  font-weight: 400;
`

export const H3 = styled(H1.withComponent('h3'))`
  font-size: calc(18rem / 16);
  font-weight: 500;
`

export const H4 = styled(H1.withComponent('h4'))`
  font-size: 1rem;
`

export const HR = styled.hr`
  border-bottom: 1px solid ${colors.BORDER_COLOR};
  margin-top: calc(30rem / 16);
  margin-bottom: calc(30rem / 16);
  ${props => props.halfMarginTop &&
    ` 
      margin-top: calc(8rem / 16);
    `
  }
  ${props => props.noBottomMargin &&
    ` 
      margin-bottom: 0;
    `
  }
  ${props => props.noTopMargin &&
    ` 
      margin-top: 0;
    `
  }
`


export const B = styled.b`
  ${props => props.block &&
    `
      display: block;
    `
  }
`

export const SPAN = styled.span`
  ${props => props.block &&
    `
      display: block;
    `
  }
  ${props => props.textDark &&
    `
      color: ${colors.GRAY_DARK};
    `
  }
`
export const A = styled.a`
  color: ${colors.BRAND_GREEN};
  &:hover{
    text-decoration: underline;
  }
  ${props => props.block &&
    `
      display: block;
    `
  }
  ${props => props.noHover &&
    `
      text-decoration: unset;
    `
  }
  ${props => props.textNormal &&
    `
      color: ${colors.TEXT_COLOR};
    `
  }
  ${props => props.textDark &&
    `
      color: ${colors.GRAY_DARK};
    `
  }
`
export const StyledLink = styled(({ textDark, children, ...rest }) => (
  <Link {...rest}>{children}</Link>
))`
  color: ${colors.BRAND_GREEN};
  &:hover{
    text-decoration: underline;
  }
  ${({ textDark }) => (textDark ? `color: ${colors.GRAY_DARK};` : '')}
`;

export const Stripe = styled.p`
  position: relative;
  text-align: center;
  margin: 0;
  background: ${colors.GRAY_MEGA_LIGHT};
  border-bottom: 1px solid ${colors.BORDER_COLOR};
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 13px 20px;
  line-height: 1;
  font-size: 13px;
  img{
    display: inline-block;
    width: 45px;
    height: auto;
    margin-left: 20px;
  }
  ${media.minWidth(sizes.tabletNarrow )`{
      top: -4rem;
      font-size: 16px;
      img{
        width: 60px;
      }
    }`
  }
`

export const ProfileFigure = styled.figure`
  img { display: none; }
  background-color: ${colors.GRAY_ULTRA_LIGHT};
  display: block;
  width: calc(216rem / 16);
  height: calc(216rem / 16);
  border-radius: 50%;
  margin: calc(-108rem / 16) auto 22px;
  position: relative;
  border: 2px solid white;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  ${props => props.backgroundImage && `
    background-image: url(${props.backgroundImage});
  `}
  ${props => props.hide && `
    display: none;
  `}
`
export const DL = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin-left: 0;
  margin-bottom: calc(38rem / 16);
  padding-left: 0;
  border-top: 1px solid ${colors.BORDER_COLOR};
  dt{
    flex-basis: calc(40%);
  }
  dd{
    flex-basis: calc(60%);
  }
  dt, dd{
    border-bottom: 1px solid ${colors.BORDER_COLOR};
    padding: 10px 20px;
    margin: 0;
    ${media.maxWidth(sizes.tabletNarrow - 1)`{
      &:nth-of-type(odd){
        background: ${colors.GRAY_MEGA_LIGHT}
      }
    }`
   }
  }
  dt{
    ${media.minWidth(sizes.tabletNarrow)`{
        flex-basis: calc(20%);
      }`
    }
  }
  dd{
    ${media.minWidth(sizes.tabletNarrow)`{
        flex-basis: calc(30%);
      }`
    }
  }
  dt:nth-child(8n+1), dt:nth-child(8n+3){
    ${media.minWidth(sizes.tabletNarrow)`{
        & + dd{
          background: ${colors.GRAY_MEGA_LIGHT}
        }
        background: ${colors.GRAY_MEGA_LIGHT}
      }
    }`
  }
}
`
export const TABLE = styled.table`
  margin-bottom: 1rem;
  width: 100%;
  th{
    font-weight: normal;
  }
`



// WEBPACK FOOTER //
// ./src/modules/common/components/elements/index.js